import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import cn from 'classname';
import { Cell } from 'fixed-data-table-2';

const propTypes = {
	title: PropTypes.string,
	groupDayPeriod: PropTypes.string,
	classNameModify: PropTypes.string,
	onToggleExpandAllRows: PropTypes.func,
	onOrder: PropTypes.func,
	currentOrderDuration: PropTypes.string,
	rowsVisibilityConfig: PropTypes.object,
	activeCell: PropTypes.array
};

const Header = props => (
	<Cell>
		<div className={cn(
			`activity-table-wrapper__cell activity-table-wrapper__cell--header`,
			props.classNameModify && `activity-table-wrapper__cell--${props.classNameModify}`
		)}>
			{ moment(props.title, moment.ISO_8601).isValid() &&  (
				<div className="header">
					<span className="header__date font-roboto-medium">{getDateTitle(props)}</span>
					<div className="header-value-th">
						{ props.activeCell && props.activeCell.map(cellName => {
							let title = '';

							switch (cellName) {
								case 'total': title = 'Total'; break;
								case 'approve': title = 'App %'; break;
								case 'accepted': title = 'Orders'; break;
							}

							return <div key={cellName} className="header-value-th__item">{title}</div>;
						}) }
					</div>
				</div>
			) }

			{ !moment(props.title, moment.ISO_8601).isValid() && (
				<span className="font-roboto-medium">
					<span className="title">
						<span
							className={`title__affiliate title__affiliate--order-${props.currentOrderDuration}`}
							onClick={props.onOrder}>
							{props.title}
						</span>
						<span
							className={cn(
								'title__expand',
								props.rowsVisibilityConfig.method === 'show' && 'title__expand--opened'
							)}
							onClick={props.onToggleExpandAllRows}
						>
							{ props.rowsVisibilityConfig.method === 'show' ? 'Close' : 'Open' }
						</span>
					</span>
				</span>
			)}
		</div>
	</Cell>
);

const getDateTitle = ({title, dateRange, groupDayPeriod}) => {
	const date = moment(title, moment.ISO_8601);
	if (moment(date).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')) {
		return 'Today';
	}
	if (groupDayPeriod == 1) {
		return moment(date).format('DD.MM');
	}
	let lastDate = moment(date).add(groupDayPeriod - 1, 'days');
	if (lastDate >= moment(dateRange.end)) {
		lastDate = moment(dateRange.end);
	}
	return `${moment(date).format('DD.MM')} - ${lastDate.format('DD.MM')}`;
};

Header.propTypes = propTypes;
export default Header;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates-activity/components/table/cells/header.js